import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import { useLenis } from '@studio-freight/react-lenis';

const ScrollManager = () => {
	const location = useLocation();
	const lenis = useLenis();

	useEffect(() => {
		if (!lenis) return;

		// Kill momentum and hard reset
		lenis.stop();
		lenis.scrollTo(0, { immediate: true, force: true });
		lenis.start();
	}, [location.pathname, lenis]);

	return null;
};

export default ScrollManager;
